import { apiClient } from "../config";

async function getMarkerStylesDropdown(params: any) {
  const res = await apiClient.get(`/admin/marker-style/dropdown`, { params });
  return res.data;
}

export default getMarkerStylesDropdown;
